import React from 'react'
import { Text, Button } from '@components/UI'

const End = ({ small, onExit }) => {
  return (
    <div className='gp-feedback-end'>
      <div>
        <Text className='party'>🎉</Text>
        <Text
          className={`${small ? 'text-g' : 'text-h'} color-f`}
          style={{ marignTop: 16 }}
        >
          Thanks for having time with us!
        </Text>
        {!small && (
          <Text
            className={`${small ? 'text-c' : 'text-e'}`}
            style={{ color: 'rgba(255, 255, 255, .45)', marginTop: 8 }}
          >
            You can access all information about this lesson from your dashboard
            at anytime
          </Text>
        )}
      </div>
      <div className='actions-container'>
        <Button
          className='back medium'
          theme={`${small ? 'j inverted' : 'f'} interactive`}
          icon={{
            name: small ? 'close' : 'ok',
            value: small ? 'Close' : 'Back to the Dashboard',
            group: small ? 'a' : 'a2'
          }}
          group={small ? 'a3' : 'a4'}
          events={{
            onClick: onExit
          }}
        />
      </div>
    </div>
  )
}

export default End
